import { render, staticRenderFns } from "./ProjectApplications.vue?vue&type=template&id=8be298fe&scoped=true&"
import script from "./ProjectApplications.vue?vue&type=script&lang=js&"
export * from "./ProjectApplications.vue?vue&type=script&lang=js&"
import style0 from "@/sass/09_helpers/_vuejs-transitions.scss?vue&type=style&index=0&id=8be298fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be298fe",
  null
  
)

export default component.exports